<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <router-view v-show="!overlayLoading" />
    <div class="text-center">
      <v-overlay :z-index="zIndex" :value="overlayLoading" opacity="0.9">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <h2 class="mt-5">Please Wait...</h2>
      </v-overlay>
    </div>

    <v-overlay :z-index="999" :value="isLoading" opacity="0.5">
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        "
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <span
          v-if="percentLoading.is_use"
          style="position: absolute; top: 20px"
        >
          {{ percentLoading.percent }}%
        </span>
        <h2 class="mt-5">Please Wait</h2>
      </div>
    </v-overlay>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    zIndex: 205,
    isLoading: false,
    percentLoading: {
      is_use: false,
      percent: 0,
    },
  }),
  provide() {
    return {
      isAppLoading: async (open, time) => {
        return new Promise((resolve) => {
          const _time = time || 0;
          setTimeout(() => {
            this.isLoading = open;
            if (!open) {
              this.percentLoading.is_use = false;
              this.percentLoading.percent = 0;
            }
            resolve(true);
          }, _time);
        });
      },
      isAppLoadingPercent: async (is_use, percent) => {
        const onSleep = (msec) => {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, msec || 500);
          });
        };
        this.percentLoading.is_use = is_use || false;
        const new_percent = percent || 0;
        const old_percent = this.percentLoading.percent;
        const diff = new_percent - old_percent;
        if (diff >= 0) {
          for (let i = 0; i < diff; i++) {
            const cur_percent = old_percent + i + 1;
            this.percentLoading.percent = cur_percent;
            await onSleep(2);
          }
        } else {
          this.percentLoading.percent = 0;
        }
      },
    };
  },
  computed: {
    overlayLoading: {
      set() {
        this.$store.commit("defaultSystem/SET_LOADING", false);
      },
      get() {
        return this.$store.getters["defaultSystem/getLoading"];
      },
    },
  },
  watch: {
    overlayLoading: {
      handler() {
        this.overlayLoading;
      },
      deep: true,
    },
  },
};
</script>

<style>
@import url("./assets/styles/ql-editor.css");

.svc-creator__banner {
  display: none !important;
}
</style>

<style scoped>
.main {
  max-height: 2000px;
}
.menu-text {
  /* position: absolute; */
  z-index: 30;
}
.hamberger-menu {
  z-index: 40;
}
.display-coin {
  position: absolute;
  z-index: 50;
}
.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 100px;
}

@import url("https://fonts.googleapis.com/css2?family=Athiti:wght@400;500;600&display=swap");

body {
  font-family: "Poppins", "Athiti" !important;
}
</style>
